// extracted by mini-css-extract-plugin
export default {"header":"SecondHeader_header__TGpmL","content":"SecondHeader_content__Lp9XS","icon":"SecondHeader_icon__bfjGq","first":"SecondHeader_first__XPoon","p":"SecondHeader_p__DdLQz"};